import { useCallback, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { applyNodeChanges } from '../core';
import type { Node, NodeChange } from '../core';

/** v11 `useNodesState(initialNodes)` → `[nodes, setNodes, onNodesChange]`; changes are applied with `applyNodeChanges`. */
export const useNodesState = <TNode extends Node>(
  initialNodes: TNode[],
): [TNode[], Dispatch<SetStateAction<TNode[]>>, (changes: NodeChange[]) => void] => {
  const [nodes, setNodes] = useState(initialNodes);
  const onNodesChange = useCallback((changes: NodeChange[]) => setNodes((current) => applyNodeChanges(changes, current)), []);
  return [nodes, setNodes, onNodesChange];
};
